/**
 * components/filters/DateRangeFilter.js — Огнооны хязгаар (эхлэх – төгсөх).
 *
 * ⚠ Өмнө нь native `<input type="date">` ашигладаг байсан тул браузер
 * `mm/dd/yyyy` гэсэн АНГЛИ хэлбэрийн зөвлөмжийг харуулдаг байв (энэ нь
 * браузерын локалиас хамаардаг, JS-ээс өөрчлөх боломжгүй). Одоо antd
 * RangePicker — монгол зөвлөмжтэй, `YYYY-MM-DD` форматтай.
 *
 * Утга нь ГАДНАА "YYYY-MM-DD" ТЕКСТ хэвээр (`from` / `to`) — дуудагч
 * хуудсууд өөрчлөх шаардлагагүй.
 *
 * Props:
 *   from, to               — "YYYY-MM-DD" тэмдэгт мөр
 *   onFromChange(value), onToChange(value)
 *   basis                  — flex-basis (responsive)
 *   presets                — товчилсон сонголт харуулах эсэх (default true)
 */
import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

const FMT = "YYYY-MM-DD";
const toMoment = (v) => (v ? moment(v, FMT) : null);

export default function DateRangeFilter({
  from,
  to,
  onFromChange,
  onToChange,
  fromTitle = "Эхлэх огноо",
  toTitle = "Төгсөх огноо",
  basis = 250,
  presets = true,
}) {
  // Түгээмэл хугацаанууд — нэг товшилтоор. «Энэ сар» нь анхдагч сонголт
  // (сарын 1-нээс сарын сүүлийн өдөр хүртэл).
  const ranges = presets
    ? {
        "Энэ сар": [moment().startOf("month"), moment().endOf("month")],
        "Өнгөрсөн сар": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
        "Энэ улирал": [moment().startOf("quarter"), moment().endOf("quarter")],
        "Энэ жил": [moment().startOf("year"), moment().endOf("year")],
      }
    : undefined;

  return (
    <div
      style={{
        // Нарийн дэлгэцэд бүтэн мөр эзэлж, өргөн дэлгэцэд байгалийн хэмжээндээ
        flex: `1 1 ${typeof basis === "number" ? `${basis}px` : basis}`,
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <RangePicker
        allowEmpty={[true, true]}
        style={{ width: "100%" }}
        format={FMT}
        ranges={ranges}
        placeholder={[fromTitle, toTitle]}
        value={[toMoment(from), toMoment(to)]}
        onChange={(dates) => {
          onFromChange?.(dates?.[0] ? dates[0].format(FMT) : "");
          onToChange?.(dates?.[1] ? dates[1].format(FMT) : "");
        }}
      />
    </div>
  );
}

/** Тухайн сарын эхэн ба төгсгөл — хуудсуудын анхдагч утга болгоход */
export function currentMonthRange() {
  return {
    from: moment().startOf("month").format(FMT),
    to: moment().endOf("month").format(FMT),
  };
}
